import request from '@/utils/request'

import sapRequest from '@/utils/sap-request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 公共api
 * 获取用户信息
 * @param {*} params
 */
export function apiLoginCheck(token, data) {
  return request({
    url: BASE_API() + '/session',
    method: 'post',
    headers: {
      'X-Auth-Token': token
    },
    data
  })
}

/**
 * 公共api
 * 获取用户信息
 * @param {*} params
 */
export function getUserInfo(params) {
  return request({
    url: BASE_API() + '/contract/getUserInfo',
    method: 'get',
    params
  })
}

/**
 * 公共api
 * 上传附件
 * @param {*} params
 */
export function webUploadFile(data) {
  return request({
    url: BASE_API() + '/webUpload/ajaxUpload',
    method: 'post',
    data
  })
}

/**
 * 公共api
 * 查询附件
 * @param {*} params
 */
export function queryFiles(data) {
  return request({
    url: BASE_API() + '/attachment/doQuery',
    method: 'post',
    headers: {
      needFormat: true,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

/**
 * 公共api
 * 删除附件
 * @param {*} params
 */
export function deleteFiles(data) {
  return request({
    url: BASE_API() + '/attachment/doDelete',
    method: 'post',
    headers: {
      needFormat: true,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

/**
 * 全国行政区域
 * @param {*} params
 */
export function apiCityArea(params) {
  return request({
    url: BASE_API() + '/cityArea/findAll',
    method: 'get',
    params
  })
}

/**
 * 分页查询客户主数据信息
 * @param {*} params
 */
export function apiFindAllClientInfo(data) {
  return request({
    url: '/mdm/client/findAllClientInfo',
    method: 'post',
    data
  })
}

/**
 * 客户弹窗查询
 */
export function apiSapClientFindInfo(data) {
  return sapRequest({
    url: '/sap/bc/ztpm/to_new_crm/transdata/bp_search',
    method: 'post',
    data
  })
}

/**
 * 单个客户查询
 */
export function apiSapSingleClientInfo(data) {
  return sapRequest({
    url: '/sap/bc/ztpm/to_new_crm/transdata/bp_search_by_id',
    method: 'post',
    data
  })
}

/**
 * 销售计划弹窗产品查询
 * @param {*} params
 */
export function apiSelectSaleProduct(data) {
  return sapRequest({
    url: '/sap/bc/ztpm/to_new_crm/transdata/product_ovs',
    method: 'post',
    data
  })
}

/**
 * 通用弹窗产品查询
 * @param {*} params
 */
export function apiSelectProduct(data) {
  return sapRequest({
    url: '/sap/bc/ztpm/to_new_crm/transdata/bp_pro_search',
    method: 'post',
    data
  })
}

/**
 * 组织机构查询
 * @param {*} params
 */
export function apiQueryOrg(data) {
  return request({
    url: BASE_API() + '/org/queryOrgs',
    method: 'get',
    params: data
  })
}

/**
 * 组织机构搜索
 * @param {*} params
 */
export function apiSlicedQueryOrgs(data) {
  return request({
    url: BASE_API() + '/org/slicedQueryOrgs',
    method: 'get',
    params: data
  })
}

/**
 * 组织机构搜索
 * @param {*} params
 */
export function apiSlicedQueryOrgsP(data) {
  return request({
    url: BASE_API() + '/org/slicedQueryOrgs',
    method: 'post',
    data,
    headers: {
      needFormat: true
    }
  })
}
/**
 * 平台查询字典
 * @param {*} params
 */
export function apiPlatformFindDictionaryByCode(params) {
  return request({
    url: BASE_API() + '/platform/findDictionaryByCode',
    method: 'get',
    params
  })
}

/**
 * 查询计划类型与渠道类型的对应关系
 * @param {*} params
 */
export function apiFindPlanTypeToChannel(params) {
  return request({
    url: BASE_API() + '/deliveryControl/findPlanTypeToChannel',
    method: 'get',
    params
  })
}

/**
 * 查询计划类型与价格类型的对应关系
 * @param {*} params
 */
export function apiFindPlanTypeLinkPriceType(params) {
  return request({
    url: BASE_API() + '/planType/findPlanTypeLinkPriceType',
    method: 'get',
    params
  })
}

/**
 * 保存计划类型与渠道类型的对应关系
 * @param {*} params
 */
export function apiSavePlanTypeToChannel(data) {
  return request({
    url: BASE_API() + '/deliveryControl/savePlanTypeToChannel',
    method: 'post',
    data
  })
}

/**
 * 模板下载
 * @param {*} params
 */
export function apiExportExcelTemplate(templateCode) {
  return request({
    url: BASE_API() + `/excelImport/exportExcelTemplate?templateCode=${templateCode}`,
    method: 'get'
  })
}


/**
 * 文件下载
 * @param {*} params
 */
export function apiAttachmentDownFile(params) {
  return request({
    url: BASE_API() + `/attachmentDownFile`,
    method: 'post',
    params,
    responseType: 'blob'
  })
}

/**
 * excel导入
 * @param {*} params
 */
export function apiExcelImport({ formData, templateCode }) {
  return request({
    url: BASE_API() + `/excelImport/upload?templateCode=${templateCode}`,
    method: 'post',
    data: formData
  })
}

/**
 * 查询导入的excel数据  查询导入到临时表的数据
 * @param {*} params
 */
export function apiGetExcelImportData(data) {
  return request({
    url: BASE_API() + '/excelImport/data',
    method: 'get',
    params: data
  })
}

/**
 * 删除导入临时数据
 * @param {*} params
 */
export function apiDeleteExcelImportData(data) {
  return request({
    url: BASE_API() + '/excelImport/data/deleteByBatchNumber',
    method: 'get',
    params: data
  })
}

/**
 * 将导入临时表的数据保存到正式业务表
 * @param {*} params
 */
export function apiSaveExcelImportData(data) {
  return request({
    url: BASE_API() + '/excelImport/data/saveToBiz',
    method: 'post',
    data
  })
}

/**
 * 获取岗位
 * @param {*} params
 */
export function apiQueryPersonMembersByPersonIda(data) {
  return request({
    url: BASE_API() + '/org/queryPersonMembersByPersonId',
    method: 'post',
    data
  })
}

/**
 * 切换岗位
 * @param {*} params
 */
export function apiSwitchOperator(data) {
  return request({
    url: BASE_API() + '/switchOperator',
    method: 'post',
    data,
    headers: {
      needFormat: true,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 获取代办草稿状态的数据
 * @param {*} params
 */
export function apiFindSavedApplyBill() {
  return request({
    url: BASE_API() + '/wantgoods/findSavedApplyBill',
    method: 'get'
  })
}

/**
 * 获取消息列表
 * @param {*} params
 */
export function apiFindUnreadMsg(data) {
  return request({
    url: BASE_API() + '/message/findUnreadMsg',
    method: 'post',
    data
  })
}

/**
 * 修改消息状态到已读
 * @param {*} params
 */
export function apiMessageEditStatus(params) {
  return request({
    url: BASE_API() + '/message/editStatus',
    method: 'post',
    params
  })
}

/**
 * 一键已读
 * @param {*} params
 */
export function apiMessageReadAll(params) {
  return request({
    url: BASE_API() + '/message/readAll',
    method: 'post',
    params
  })
}

/**
 * 订单解锁加锁
 */
export function apiOrderLock(data) {
  return request({
    url: BASE_API() + '/businessLock/checkLock',
    method: 'post',
    data,
    headers: {
      needFormat: true,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 查询待审批的要货单
 */
export function apiWantGoodsApproveList(data) {
  return request({
    url: BASE_API() + '/wantGoodsBill/findAll',
    method: 'post',
    data
  })
}

/**
 * 要货批量审批
 */
export function apiWantGoodsApprove(data) {
  return request({
    url: BASE_API() + '/wantGoodsBill/advance',
    method: 'post',
    data
  })
}

/**
 * 要货日志
 */
export function apiSystemlog(data) {
  return request({
    url: BASE_API() + '/wantgoods/commdatalog',
    method: 'post',
    data
  })
}
/**
 * 运行日志
 */
export function apiSystemRunninglog(data) {
  return request({
    url: BASE_API() + '/wantgoods/readFile',
    method: 'post',
    data
  })
}
/**
 * 修改密码
 */
export function apiUpdatePassword(data) {
  return request({
    url: BASE_API() + '/org/updatePassword',
    method: 'post',
    data,
    headers: {
      needFormat: true
    }
  })
}

/*
  * 保存上传的附件信息到HANA库
 */
export function saveHanaUploadFile(data) {
  return request({
    url: BASE_API() + '/setShunting/saveHanaAttachment',
    method: 'post',
    data
  })
}

/*
  * 删除上传的附件信息到HANA库
 */
export function deleteHanaAttachment(data) {
  return request({
    url: BASE_API() + '/setShunting/deleteHanaAttachment',
    method: 'post',
    data
  })
}

/**
  * 查询附件的BIZID
 */
export function apiFindAttachBizId(params) {
  return request({
    url: BASE_API() + '/setShunting/findBizIdByBizCode',
    method: 'post',
    params
  })
}

/**
 * 查询附件的BIZID
 */
export function apiFindAttachId(params) {
  return request({
    url: BASE_API() + '/setShunting/findIdByBizCode',
    method: 'post',
    params
  })
}

/**
 * 下载合同计划量调整表
 */
export function printContractPlan(data) {
  return request({
    url: BASE_API() + '/wantgoods/printContractPlan',
    method: 'post',
    data,
    responseType: 'blob'
  })
}




// WEBPACK FOOTER //
// ./src/api/common.js